import clsx from "classnames";
import ScrollWrapper from "../ScrollWrapper/ScrollWrapper";
import { useStyles } from "./AppBar.style";
import { map } from "lodash";
export interface IHeaderProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  leftItems?: React.ReactNode;
  centerItems?: React.ReactNode;
  rightItems?: React.ReactNode;
  tabs?: React.ReactNode;
}

const AppBar: React.FC<IHeaderProps> = ({
  leftItems,
  centerItems,
  rightItems,
  tabs,
  ...otherProps
}) => {
  const classes = useStyles();
  const config = {
    leftItems,
    centerItems,
    rightItems,
  };

  return (
    <ScrollWrapper isTabs={!!tabs}>
      <div className={clsx(classes.root, otherProps.className)}>
        {map(Object.entries(config), ([key, item], index) => {
          if (!item) return null;
          return (
            <div
              key={index}
              className={clsx(
                classes.item,
                key === "centerItems" && classes.centerItems,
              )}
            >
              {item}
            </div>
          );
        })}
      </div>
      {tabs}
    </ScrollWrapper>
  );
};

export default AppBar;
